/**
 * Custom accordion element that implements a grid-based accordion
 * Uses aria-expanded attribute to control open/closed state
 */
class AccordionElement extends HTMLElement {
  constructor() {
    super();
    this.accordionTitle = this.querySelector(".grafikr-accordion__title");
    this.bindEvents();
    this.initializeState();
  }

  /**
   * Set up event listeners
   */
  bindEvents() {
    if (this.accordionTitle) {
      this.accordionTitle.addEventListener("click", () => this.toggle());
    }
  }

  /**
   * Initialize the accordion's state based on aria-expanded attribute
   */
  initializeState() {
    // Check if aria-expanded attribute exists and is set to "true"
    const expanded = this.hasAttribute("aria-expanded") && this.getAttribute("aria-expanded") === "true";

    // If it doesn't exist, create it and set to closed by default
    if (!this.hasAttribute("aria-expanded")) {
      this.setAttribute("aria-expanded", "false");
    }

    // Make the title button accessible
    if (this.accordionTitle) {
      this.accordionTitle.setAttribute("role", "button");
      this.accordionTitle.setAttribute("aria-expanded", expanded ? "true" : "false");
      this.accordionTitle.setAttribute("tabindex", "0");
    }
  }

  /**
   * Toggle the accordion open/closed state
   */
  toggle() {
    const isExpanded = this.getAttribute("aria-expanded") === "true";
    const newState = isExpanded ? "false" : "true";

    this.setAttribute("aria-expanded", newState);

    if (this.accordionTitle) {
      this.accordionTitle.setAttribute("aria-expanded", newState);
    }
  }
}

// Register the custom element
customElements.define("accordion-element", AccordionElement);
